import type { MouseEvent, PointerEvent } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import type { NavigationItem } from '@/types/layout.types';
import { MOBILE_BOTTOM_NAV_ICONS } from '@/constants';
import { MobileBottomNavItem } from './MobileBottomNavItem';

interface MobileBottomNavProps {
	show: boolean;
	bottomNav: NavigationItem[];
	currentPageName: string;
	onNavigate: (path: string) => void;
	onLoginClick?: () => void;
	loginPointerProps?: {
		onPointerDown: (e: PointerEvent) => void;
		onClick: (e: MouseEvent) => void;
	};
	isRegisteredUser: boolean;
}

export function MobileBottomNav({
	show,
	bottomNav,
	currentPageName,
	onNavigate,
	onLoginClick,
	loginPointerProps,
	isRegisteredUser,
}: MobileBottomNavProps) {
	if (!show) return null;

	return (
		<nav
			className={cn(
				'pointer-events-none fixed inset-x-0 bottom-0 z-100 flex flex-col items-center gap-2 px-4 pb-[max(32px,env(safe-area-inset-bottom))]',
				!isRegisteredUser && 'pt-3'
			)}
			id="bottom-nav"
			aria-label="Main navigation"
		>
			{!isRegisteredUser && (
				<Button
					onPointerDown={loginPointerProps?.onPointerDown}
					onClick={loginPointerProps?.onClick ?? onLoginClick}
					className="pointer-events-auto h-11 w-full rounded-full border-b border-[#1E2748] bg-blue-custom-2 text-base font-bold text-[#F7F7F8] hover:bg-blue-custom-2/80"
				>
					Login
				</Button>
			)}
			<div className="pointer-events-auto flex h-[68px] w-full items-start justify-between rounded-[48px] border-[0.5px] border-solid border-[#E4E8F3] bg-white px-6 pb-2 pt-[7px] shadow-[0_16px_16px_rgba(93,104,133,0.24)]">
				{bottomNav.map((item) => {
					let isActive = currentPageName.toLowerCase() === item.name.toLowerCase();
					if (item.name.toLowerCase() === 'events') {
						if (currentPageName === 'LobbyDetails' || currentPageName === 'EventDetails') {
							isActive = true;
						}
					} else if (item.name.toLowerCase() === 'home') {
						if (currentPageName === 'Auth') {
							isActive = true;
						}
					}

					return (
						<MobileBottomNavItem
							key={item.name}
							item={item}
							icon={MOBILE_BOTTOM_NAV_ICONS[item.tabName] ?? item.icon}
							isActive={isActive}
							onNavigate={onNavigate}
						/>
					);
				})}
			</div>
		</nav>
	);
}
